import React from 'react';
import clsx from 'clsx';

import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
  ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Text from '@/elements/Text/Text.component';
import Button from '@/elements/Button/Button.component';

import { IProps } from '@/blocks/HeroHeaderFiftyFiftyBlock/HeroHeaderFiftyFiftyBlock.interface';
import '@/blocks/HeroHeaderFiftyFiftyBlock/HeroHeaderFiftyFiftyBlock.styles.css';
import Image from '@/elements/Image/Image.component';

export const HeroHeaderFiftyFiftyBlock: React.FC<IProps> = ({
  backButton,
  title,
  description,
  buttons,
  mediaPosition = 'cover', // Default to cover for fullwidth hero
  className,
  backgroundColor,
  backgroundImage,
  ...blockWrapperProps
}) => {
  const imageColOrder = clsx({
    'order-1': mediaPosition === 'left',
    'order-2': mediaPosition === 'right',
  });

  const textColOrder = clsx({
    'order-2': mediaPosition === 'left',
    'order-1': mediaPosition === 'right',
  });

  // Render content section
  const renderContent = () => (
    <>
      {backButton && (
        <Button
          {...backButton}
          icon="chevron-left"
          iconPosition="before"
          size="sm"
          className="heroHeaderFiftyFiftyBlock__backButton"
        />
      )}
      {title && (
        <Heading level={1} className="heroHeaderFiftyFiftyBlock__title" html={title} />
      )}
      {description && (
        <Text className="heroHeaderFiftyFiftyBlock__description" html={description} />
      )}
      {buttons && buttons.length > 0 && (
        <div className="heroHeaderFiftyFiftyBlock__buttons">
          {buttons.map((btn, idx) => (
            <Button
              key={`hero-banner-block-cta-${idx}`}
              {...btn}
              className="heroHeaderFiftyFiftyBlock__button"
            />
          ))}
        </div>
      )}
    </>
  );
  const isFiftyFiftyLayout =
    mediaPosition === 'left' || mediaPosition === 'right';

  return (
    <BlockWrapper
      className={clsx('heroHeaderFiftyFiftyBlock', className, {
        'heroHeaderFiftyFiftyBlock--fiftyFifty': isFiftyFiftyLayout,
        'heroHeaderFiftyFiftyBlock--mediaLeft': mediaPosition === 'left',
        'heroHeaderFiftyFiftyBlock--mediaRight': mediaPosition === 'right',
      })}
      backgroundColor={
        isFiftyFiftyLayout && !backgroundColor ? 'brand-3' : backgroundColor
      }
      backgroundImage={!isFiftyFiftyLayout ? backgroundImage : undefined}
      {...blockWrapperProps}
    >
      <ContentWrapper
        className={clsx('heroBanner-contentwrapper', {
          'heroBanner-contentwrapper--fiftyFifty': isFiftyFiftyLayout,
          'heroBanner-contentwrapper--fullWidth':
            blockWrapperProps.layout === 'fullwidth',
        })}
      >
        {/* Text Column */}
        <ContentColumn
          className={clsx('heroHeaderFiftyFiftyBlock__textColumn', textColOrder, {
            'contentColumn__layout--twoThirds': mediaPosition === 'cover',
          })}
        >
          {renderContent()}
        </ContentColumn>

        {/* Image Column */}
        {backgroundImage && isFiftyFiftyLayout && (
          <ContentColumn
            className={clsx('heroHeaderFiftyFiftyBlock__imageColumn', imageColOrder)}
          >
            <Image {...backgroundImage} className="heroHeaderFiftyFiftyBlock__image" rounded={true} />
          </ContentColumn>
        )}
      </ContentWrapper>
    </BlockWrapper>
  );
};

export default HeroHeaderFiftyFiftyBlock;